/* eslint camelcase: 0 */
import { toFileProps } from './file'
import { Appointment, AppointmentDetail, AppointmentRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IAppointmentProps, EmptyAppointmentPropsFactory, validProposals } from '@/entities/Appointment'

export const toAppointmentProps = (props: Appointment | AppointmentDetail | null | undefined): IAppointmentProps => {
  if (!props) {
    return EmptyAppointmentPropsFactory()
  }

  const {
    id,
    hospital_id,
    user_id,
    doctor_id,
    user,
    hospital,
    doctor,
    reads_count,
    datetimes,
    properties,
    calendar,
    department,
    files,
    messages,
    status,
    is_hospital,
    is_appointment,
    is_schedule,
    is_result,
    is_calendar,
    is_format_changed,
    is_place_changed,
    started_at,
    ended_at,
    created_at,
    updated_at
  } = props

  return EmptyAppointmentPropsFactory({
    id,
    hospitalId: hospital_id,
    userId: user_id,
    companyId: user?.company_id,
    doctorId: doctor_id,
    user,
    hospital,
    doctor,
    readsCount: reads_count,
    datetimes,
    properties,
    calendar,
    department,
    files: files?.map(toFileProps),
    keeps: files?.map(toFileProps),
    messages,
    status,
    isHospital: is_hospital,
    isAppointment: is_appointment,
    isSchedule: is_schedule,
    isResult: is_result,
    isCalendar: is_calendar,
    isFormatChanged: is_format_changed,
    isPlaceChanged: is_place_changed,
    startedAt: started_at,
    endedAt: ended_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toAppointmentRequest = (props: IAppointmentProps): AppointmentRequest => {
  const { userId, status, isSchedule, isResult, isAppointment, isHospital, isCalendar, datetimes, properties, data, keeps, message, startedAt, endedAt } = props
  return {
    user_id: userId!,
    status: status!,
    is_schedule: isSchedule!,
    is_result: isResult!,
    is_appointment: isAppointment!,
    is_hospital: isHospital!,
    is_calendar: isCalendar!,
    // 日付未入力など、開始・終了がそろっていない候補は送信対象から除外する
    datetimes: JSON.stringify(datetimes ? { ...datetimes, proposed: validProposals(datetimes.proposed) } : datetimes),
    properties: JSON.stringify(properties),
    data: data!,
    keeps: JSON.stringify(keeps),
    message: message!,
    started_at: isCalendar ? startedAt : null,
    ended_at: isCalendar ? endedAt : null
  }
}
